<template>
  <svg :class="[svgClass, 'svg-icon__' + name]" xmlns="http://www.w3.org/2000/svg">
    <use :xlink:href="'#' + name + '--sprite'" xmlns:xlink="http://www.w3.org/1999/xlink"/>
    {{ getSvg }}
  </svg>
</template>

<script>
export default {
  name: 'svg-icon',

  props: {
    name: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: ''
    }
  },

  computed: {
    getSvg() {
      
      let icon = require(`@/assets/svg/${this.name}.svg?sprite`);
      if (Object.prototype.hasOwnProperty.call(icon, 'default')) {
        icon = icon.default;
      }
    },

    svgClass() {
      let className = 'svg-icon';
      if (this.className) {
        className += ` ${this.className}`;
      }

      if (this.size) {
        className += ` size-${this.size}`;
      }
      return className;
    }
  },
};
</script>
<!-- 
<style>
  .svg-icon {
    fill: currentColor;
    display: block;
  }
</style>


<template>
  <svg :class="[svgClass, 'svg-icon__' + name]" aria-hidden="true">
    <use :xlink:href="iconName" />
  </svg>
</template>

<script setup lang="ts">
import { computed } from 'vue';
const props = defineProps({
  name: {
    type: String,
    required: true
  },
  className: {
    type: String,
    default: () => ''
  },
  size: {
    type: String,
    default: () => ''
  }
});

const iconName = computed(() => {
  return `#icon-${props.name}`;
});

const svgClass = computed(() => {
  let className = 'svg-icon';
  if (props.className) {
    className += ` ${props.className}`;
  }

  if (props.size) {
    className += ` size-${props.size}`;
  }
  return className;
});
</script> -->
<style scoped lang="scss">
.svg-icon {
  fill: currentColor;

  &.size-48 {
    width: 48px;
    height: 48px;
  }
}
</style>
